import { useLocation, useNavigate } from 'react-router-dom'
import useSidebarLinks from '@/hooks/hexaV2SideBarMenu/useSideBarLinks'
import { useAnalytics } from '@/hooks/useAnalytics'
import { createActionAnalytics } from '@/resources/utils/analytics'
import { useMenuContext } from '@/contexts/menu'
import { HexaV2NavBar, HexaV2NavItemsContainer } from '@/components/hexa-v2'
import { SidebarMenuItem } from '@/resources/types'

import SplitControlledMenuItem from './components/SplitControlledMenuItem'
import UtilityMenuItems from './components/UtiltyMenuItems'

import * as S from './styles'

const HexaV2SideBarMenu = () => {
  const navigate = useNavigate()
  const { links } = useSidebarLinks()
  const { pathname } = useLocation()
  const analytics = useAnalytics()

  const { isMenuOpen, isMobile, setIsMenuOpen } = useMenuContext()

  const showMenu = !isMobile || isMenuOpen

  const handleCollapse = ({
    detail,
  }: CustomEvent<{ detail: { collapsed: boolean } }>) => {
    const isCollapsed = detail.detail.collapsed
    setIsMenuOpen(!isCollapsed)
  }

  const handleChangeActive = () => {
    if (isMobile) setIsMenuOpen(false)
  }

  const isItemActive = (pageLink: string) => {
    return pathname === pageLink
  }

  const handleMenuItemClick = (menuItem: SidebarMenuItem) => {
    const { eventName, data } = createActionAnalytics({
      type: 'Menu',
      componentName: menuItem.text,
      pathname,
    })

    void analytics(eventName, data)

    navigate(menuItem.to || '')
  }

  return (
    <S.MenuContainer className="hidden-print">
      {showMenu && (
        <S.NavBarContainer>
          <HexaV2NavBar
            onHxCollapse={handleCollapse}
            onHxChangeActive={handleChangeActive}
            collapsed={!isMenuOpen}
            navbarType={isMobile ? 'click' : 'mouseEnter'}
          >
            <HexaV2NavItemsContainer>
              {links.map(item => (
                <SplitControlledMenuItem
                  key={item.id}
                  menuItem={item}
                  onClick={clickedItem =>
                    handleMenuItemClick(clickedItem ?? item)
                  }
                  isItemActive={isItemActive(item.to || '')}
                />
              ))}
            </HexaV2NavItemsContainer>

            <UtilityMenuItems isMobile={isMobile} navigate={navigate} />
          </HexaV2NavBar>
        </S.NavBarContainer>
      )}
    </S.MenuContainer>
  )
}

export default HexaV2SideBarMenu
